
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialReturnGrid extends Serenity.EntityGrid<MaterialReturnRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialReturn'; }
        protected getDialogType() { return MaterialReturnDialog; }
        protected getIdProperty() { return MaterialReturnRow.idProperty; }
        protected getInsertPermission() { return MaterialReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialReturnRow.localTextPrefix; }
        protected getService() { return MaterialReturnService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(83);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[83].AutoPosting;
            this.editItem(<MaterialReturnRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 83,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}